export const setAllZones = zoneData => ({
  type: 'SET_ZONES',
  payload: zoneData,
});

export const setAllLocalZones = zoneData => ({
  type: 'SET_LOCAL_ZONES',
  payload: zoneData,
});

export const removeLocalZone = zoneData => ({
  type: 'REMOVE_LOCAL_ZONE',
  payload: zoneData,
});

export const addLocalZone = zoneData => ({
  type: 'ADD_LOCAL_ZONE',
  payload: zoneData,
});

export const editLocalZone = zoneData => ({
  type: 'EDIT_LOCAL_ZONE',
  payload: zoneData,
});
